type SrtBillingFrequency = 'monthly' | 'annual';

// Keep this browser-local. A runtime import from @optimus/models exposes
// untranspiled workspace TypeScript to Create React App's Webpack config.
// Keep these values aligned with the backend SrtUpgradePromotion model.
const SRT_UPGRADE_PROMOTION_CODE = 'UPGRADE20';

const SRT_UPGRADE_PROMOTIONAL_AMOUNT: Record<SrtBillingFrequency, number> = {
  monthly: 19.95,
  annual: 239.40,
};

export const INVALID_PROMO_CODE = 'SN_INVALID_PROMO_CODE';

export const normalizePromotionCode = (
  promotionCode: string,
): string => promotionCode.trim().toUpperCase();

export const resolvePromotionAmount = (
  promotionCode: string,
  billingFrequency: SrtBillingFrequency,
): number | null => (
  normalizePromotionCode(promotionCode) === SRT_UPGRADE_PROMOTION_CODE ?
    SRT_UPGRADE_PROMOTIONAL_AMOUNT[billingFrequency] :
    null
);
